import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import style from './header-notification-banner.module.less';
import { messages } from './messages';
import { getSubscriptionPath } from '../../routes/constants';

export const AddTaxIdBanner = () => {
  const navigate = useNavigate();

  const handleOnClick = useCallback(() => {
    navigate(getSubscriptionPath());
  }, [navigate]);

  return (
    <BannerMessageV2
      className={style['banner-padding']}
      content={
        <Text
          formattedMessageValues={{
            a: (chunks) => (
              <Button onClick={handleOnClick} theme='link'>
                {chunks}
              </Button>
            ),
          }}
          textType={TextType.Paragraph}
          value={messages.addTaxId}
        />
      }
      layout={BannerLayout.Default}
      status={BannerStatus.Info}
    />
  );
};
